import {axios} from '../Api';
import {addParams} from '../utils'

const THROTTLE_AFTER_TRIALS = 20;
const REFRESH_INTERVAL_MILLIS = 1000;
const ABANDON_AFTER_TRIALS = 1000;

export default class PoppingProgress {
    static TRACKERS = {};

    constructor(uploadId, {onPoppingProgress, onPoppingFinished, onPoppingError, onTrackingAbandoned}, refreshInterval = REFRESH_INTERVAL_MILLIS) {
        this.uploadId = uploadId;
        this.enhId = null;
        this.imageId = null;
        this.initialRefreshInterval = refreshInterval;
        this.refreshInterval = refreshInterval;
        this.pct = 0;
        this.noChangeCount = 0;
        this.onPoppingProgress = onPoppingProgress;
        this.onPoppingFinished = onPoppingFinished;
        this.onPoppingError = onPoppingError;
        this.onTrackingAbandoned = onTrackingAbandoned || onPoppingError;
        this.restartTracking();
    }

    static start = (image, callbacks) => {
        const {uploadId} = image;
        const poppingProgress = PoppingProgress.TRACKERS[uploadId];
        if (!poppingProgress) {
            const isPoppingInProgress = !image.error && image.uploadFinished && image.poppingPct < 100;
            if (isPoppingInProgress) {
                PoppingProgress.TRACKERS[uploadId] = new PoppingProgress(uploadId, callbacks);
            }
        }
    };

    restartTracking = () => {
        this.stopTracking(false);
        this.timerId = setInterval(() => {
            this.fetchPopStatus();
        }, this.refreshInterval);
    };

    stopTracking = (remove = true) => {
        if (this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
        }
        if (remove) {
            delete PoppingProgress.TRACKERS[this.uploadId];
        }
    };

    popStatusFetchSuccess = (popStatus) => {
        this.enhId = popStatus.enhancementId;
        if (!this.imageId) {
            this.imageId = popStatus.imageId;
        }
        const pct = popStatus.pct;
        if (pct === this.pct) {
            this.noChangeCount += 1;
            if (this.noChangeCount > ABANDON_AFTER_TRIALS) {
                this.error = `Could not fetch popping status after ${this.noChangeCount} trials`;
                this.stopTracking();
                if (this.onTrackingAbandoned) {
                    this.onTrackingAbandoned(this.uploadId, this.error, this.enhId);
                }
            } else {
                const interval = this.initialRefreshInterval * Math.ceil(this.noChangeCount / THROTTLE_AFTER_TRIALS);
                if (interval !== this.refreshInterval) {
                    this.refreshInterval = interval;
                    this.restartTracking();
                }
            }
            return;
        }
        if (this.noChangeCount > THROTTLE_AFTER_TRIALS) {
            this.refreshInterval = this.initialRefreshInterval;
            this.restartTracking();
        }
        this.noChangeCount = 0;

        if (pct <= 100) {
            this.pct = pct;
            if (this.onPoppingProgress) {
                this.onPoppingProgress(this.uploadId, pct, this.imageId, this.enhId);
            }
        }
        if (pct >= 100) {
            this.stopTracking();
            this.pct = 100;
            if (this.onPoppingFinished) {
                this.onPoppingFinished(this.uploadId, this.imageId, this.enhId);
            }
        }
    };

    popStatusFetchError = (err) => {
        this.error = err.message;
        this.stopTracking();
        if (this.onPoppingError) {
            this.onPoppingError(this.uploadId, this.error, this.enhId);
        }
    };

    fetchPopStatus = async () => {
        const url = addParams('/app/api/image/pop/status', {popRequestId: this.enhId, imageId: this.imageId, fileUploadId: this.uploadId});
        try {
            const response = await axios.get(url);
            this.popStatusFetchSuccess(response.data);
        } catch (error) {
            this.popStatusFetchError(error);
        }
    };
}



// WEBPACK FOOTER //
// ./src/models/PoppingProgress.js